module.exports = "https://static.wanderu.com/ui-react/_next/static/media/powered_by_google_on_white.581bd767.png";